import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Selection } from '@nextui-org/react';
import React, { useEffect } from 'react';

import { ServerSchema } from '@common/types';
import { connectionTypeMap } from '@portal/constant';

type ConnectionType = ServerSchema['connectionType'];

export const SelectConnectionTypeUI = ({
  onSelectedChange,
  value,
}: {
  onSelectedChange: (_: ConnectionType) => void;
  value?: ConnectionType;
}) => {
  const [selected, setSelected] = React.useState<Set<ConnectionType>>(new Set([value || 'persistent-ssh']));

  useEffect(() => {
    if (!value) return;
    setSelected(new Set([value]));
  }, [value]);

  useEffect(() => {
    onSelectedChange(Array.from(selected)[0]);
  }, []);

  useEffect(() => {
    onSelectedChange(Array.from(selected)[0]);
  }, [selected]);

  const selection = Object.entries(connectionTypeMap)
    .filter(([key]) => key !== 'listen')
    .map(([key, value]) => <DropdownItem key={key}>{value}</DropdownItem>);

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button variant='bordered' className='w-[100%] h-[100%]'>
          Connection Type: {connectionTypeMap[Array.from(selected)[0]]}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='Single selection actions'
        variant='flat'
        disallowEmptySelection
        selectionMode='single'
        selectedKeys={selected}
        onSelectionChange={setSelected as (_: Selection) => void}
      >
        {selection}
      </DropdownMenu>
    </Dropdown>
  );
};
